// @flow

// cordova-plugin-statusbar v4 removed `overlaysWebView` and `backgroundColorByHexString`,
// and cordova-ios 8 expects the WebView to render fullscreen with safe-area insets
// handled in CSS (see `padding-top: env(safe-area-inset-top)` in AppMobileHeader.scss).
// Status bar style is set via the `StatusBarStyle` preference in config.xml.
type Props = {
    color?: 'default' | 'white',
    prevColor?: 'default' | 'white',
};

// eslint-disable-next-line no-unused-vars
const AppStatusBar = (_props: Props) => null;

export default AppStatusBar;
